<template>
  <BtnToggle 
    :class="{ active: value }"
    :title="$t('engine.manageText.modalWidget.tooltip.align.lblLift', languageEngine)"
    @click="onClick"
  >
    <i class="far fa-align-left"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
  },
  methods: {
    onClick() {
      let value = !this.value;
      let formatValue = 'left';

      this.texteditor.editor.format("align", formatValue);
      this.$emit('click');
      this.$emit('change', value);
    }
  },
}
</script>
